import React, { useState } from "react";
import sadDogImg from './unsubscribe.webp';
import styles from './styles.module.css';
import axios from "axios";

const DeleteAccount = () => {
	const [submitted, setSubmitted] = useState(false);
	const [email, setEmail] = useState('');
	const [emailError, setEmailError] = useState('');
	const [loading, setLoading] = useState(false);

	const validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!validateEmail(email)) {
			setEmailError('Please enter a valid email address.');
			return;
		}
		setEmailError('');
		setLoading(true);

		try {
			const response = await axios({
				method: 'post',
				url: process.env.REACT_APP_API_URL + '/customer/delete_account',
				headers: { "Content-Type": "application/json" },
				data: { email: email.toLowerCase() }
			});
			if (response.data && response.data.success) {
				setSubmitted(true);
			} else {
				setEmailError(response.data?.message || 'Unable to process your request. Please try again.');
			}
		} catch (error) {
			console.error('Failed to delete account:', error);
			setEmailError('Something went wrong. Please try again later.');
		} finally {
			setLoading(false);
		}
	};

	if (submitted) {
		return (
			<div className={styles.page}>
				<div className={styles.container}>
					<div className={`${styles.card} ${styles.successCard}`}>
						<div className={styles.successIcon}>
							<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
								<polyline points="20 6 9 17 4 12"></polyline>
							</svg>
						</div>
						<h1 className={styles.successTitle}>Request Received</h1>
						<p className={styles.successText}>
							Your account deletion request has been submitted. We'll process it within 30 days and send a confirmation to your email.
						</p>
						<button
							className={styles.primaryButton}
							onClick={() => window.location.href = '/'}
						>
							Back to Home
						</button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={styles.page}>
			<div className={styles.container}>
				<div className={styles.card}>
					<img
						src={sadDogImg}
						alt="Sad dog"
						className={styles.illustration}
					/>
					<p className={styles.eyebrow}>Account Deletion</p>
					<h1 className={styles.title}>We're sad to see you go</h1>
					<p className={styles.subtitle}>
						Enter your email address to request account deletion. This action cannot be undone.
					</p>

					<form onSubmit={handleSubmit}>
						<div className={styles.inputWrapper}>
							<input
								type="email"
								value={email}
								onChange={(e) => {
									setEmail(e.target.value);
									if (emailError) setEmailError('');
								}}
								placeholder="Enter your email address"
								className={styles.input}
								autoComplete="email"
							/>
							{emailError && (
								<span className={styles.error}>{emailError}</span>
							)}
						</div>

						<div className={styles.actions}>
							<button
								type="button"
								className={styles.secondaryButton}
								onClick={() => window.location.href = '/'}
							>
								I've changed my mind
							</button>
							<button
								type="submit"
								className={`${styles.primaryButton} ${styles.deleteButton}`}
								disabled={loading || !email}
							>
								{loading ? 'Processing...' : 'Delete My Account'}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default DeleteAccount;
